<template>
    <div>
        <PageHeader :page="page" :template="2" @action="createNew" v-if="!state.loading"/>
        <div class="content" v-if="!state.loading">
            <DataTable :tableData="tableData" @mark="mark" @history="showHistory"
            :rowClass="getRowClass" @edit="editTask" @view="viewTask"/>
        </div>
        <div v-if="state.loading" style="text-align: center;">
          <img src="@/assets/img/ajldr.gif" style="width:100px"/>
        </div>
    </div>

    <ModalView
        :isVisible="state.CreateModal"
        :fixclose="true"
        @close="state.CreateModal = false">
        
        <DynamicForm ref="createForm" :columns="1"
        :fields="newFields" @submit="createTask" :addMore="'Add Assignee'"
        :submitting="state.submitting" :errors="state.errors" @sendData="addAssignee"
        :success="state.success" />
    </ModalView> 

    <ModalView
      :isVisible="state.editTaskModal"
      :fixclose="true"
      @close="state.editTaskModal = false">

      <div v-if="state.gettingTask" style="text-align: center;">
        <img src="@/assets/img/ajldr.gif" style="width:100px"/>
      </div>
      <div v-else>
        <div class="temp-row" style="flex-direction: column;">
          <div class="temp-input" style="flex:1">
            <label class="lbl" for="name">Task Name</label>
            <input type="text" id="name" v-model="editData['name']">
          </div>
          <div class="temp-input" style="flex:1">
            <label class="lbl" for="name">Deadline</label>
            <CalendarView v-model="editData['due']" defaultValue="2025-01-01" />
          </div>
          <div class="temp-input" style="flex:1">
            <label class="lbl" for="name">Description</label>
            <WysiwygEditor  class="temp-input"
                v-model="editData['desc']"
                rows="2" cols="80"
              />
          </div>
        </div>

        <label class="lbl">Assign Task to</label>
        <div class="temp-row perm" v-for="(f, key) in editFields" :key="key">
          <div class="temp-input v-flex align-items-center">
            <div>
              <div v-html="icons.trash" class="ic" style="margin-right: 10px;"
              @click="deleteAssignee(key)"></div>
            </div>
            <div style="flex:1">
              <select :name="f.name" v-model="editData[f.name]">
                <option v-for="(option, i) in staff" :key="i" :value="option.value">
                  {{ option.label }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="errors" v-if="!state.submitting">
          <p v-for="(e,i) in state.errors" :key="i">{{e}}</p>
        </div>

        <div class="temp-row success" v-if="state.success" style="justify-content: center">
          <p>Form upload successful</p>
        </div>

        <div v-if="!state.submitting && !state.success" class="temp-row v-flex align-items-center justify-content-between">
          <div class="btn-primary" @click="addEFields">Add more</div>
          <div class="btn-full" @click="updateTask">Update</div>
        </div>
        <div class="temp-row" v-if="state.submitting" style="text-align: center; justify-content: center">
          <img src="@/assets/img/ajldr.gif" style="width:100px"/>
        </div>
      </div>
    </ModalView>

  <ModalView
        :isVisible="state.historyModal"
        :fixclose="true"
        @close="state.historyModal = false">
        <div v-if="!state.historyLoading">
          <HistoryItem v-for="(item, i) in history" :key="i" :hitem="item"/>
        </div>
        <div v-else style="text-align: center;">
          <img src="@/assets/img/ajldr.gif" style="width:100px"/>
        </div>
    </ModalView> 

    <ModalView
        :isVisible="state.ViewModal"
        :fixclose="true"
        @close="state.ViewModal = false">
        
        <FormView :columns="1"
            :fields="viewFields" :errors="state.errors"
            :loading="state.modalLoading" />
    </ModalView> 
</template>
<script>
import icons from '@/assets/js/icons.js';
import { defineComponent, reactive, ref, onMounted, computed, watch} from 'vue';
import PageHeader from '@/components/PageHeader.vue';
import DataTable from '@/components/DataTable.vue';
import DynamicForm from '@/components/DynamicForm.vue';
import ModalView from '@/components/ModalView.vue';
import CalendarView from '@/components/CalendarView.vue';
import WysiwygEditor from '@/components/WysiwygEditor.vue';
import call from "../composables/call.js";
import { urls } from "../assets/js/urls";
import { useRoute } from 'vue-router';
import FormView from '@/components/FormView.vue';
import { usePermissions } from '@/composables/usePermissions';
import HistoryItem from '@/components/HistoryItem.vue';

export default defineComponent({
  name: 'DepartmentsView',
  components:{PageHeader, DataTable,DynamicForm,ModalView,
    CalendarView,HistoryItem,FormView,WysiwygEditor},
  setup(){
    const viewFields=ref([]);
    const { hasPermission } = usePermissions();
    const createForm=ref(null);
    const state=reactive({CreateModal:false, submitting:false,error:[],success:false,
      loading:true,editTaskModal:false,gettingTask:false,historyModal:false,historyLoading:true,
      modalLoading:true,ViewModal:false
    });
    const svgIcons = ref(icons);
    const route = useRoute();
    const project = computed(() => route.params.project)
    const staff=ref([])
    const history=ref([])
    const page=ref({title:"Projects", btn:"Create task",
    desc:"All tasks in this project"})
    if(!hasPermission('Task Assignment', 'create')){
      page.value.btn="";
    }
    var action_label=[icons.view];
    var action=["view"];
    const editData=ref({});
    if(hasPermission('Task Assignment', 'edit')){
      action_label.push(icons.edit);
      action.push("edit")
    }
    action_label.push(icons.row_info);
    action.push("history")

    if(hasPermission('Task Assignment', 'delete')){
      // action_label.push(icons.trash);
      // action.push("delete")
    }

    const tableData = ref({
      rows: [],
      loading: true,
      columns: [
        { label: "Task name" },
        { label: "Assignee" },
        { label: "Due date" },
        { label: "Status" },
      ],
      options:{
        label:"Actions",
        action_label:action_label,
        action:action,
        rowAction:{row1:{icon:icons.check,action:"mark"}}
      },
      total:0
    });
    
    const newFields=ref([
      { name: "Create Task", number: "1",data: 
        [{ type: 'text', name: 'name', label: 'Task Name',
          value: ""  },
          { type: 'date', name: 'deadline', label: 'Deadline',
          value: ""  },
          { type: 'wysiwyg', name: 'desc', label: 'Description',
          value: ""  },
          { type: 'hidden', name: 'project', value: project.value},
        ]
      },
      { name: "Assign task", number: "2",data: 
        [{ type: 'select', name: 'assignee_1', label: 'Staff',
          options:staff}
        ]
      }
    ])
    
    const editFields=reactive([])

    function createNew(){
      state.success=false;
      state.error=[]
      state.CreateModal=true;
    }

    function setTable(msg){
      var data={}
      tableData.value.loading = false;
      tableData.value.rows.length=0
      Object.keys(msg).forEach(set => {
        data={id:msg[set].id,status:msg[set].status};
        var v=[];
        Object.keys(msg[set].val).forEach(row => {
          v.push(msg[set].val[row])
        });
        data.val=v;
        tableData.value.rows.push(data)
      });
      tableData.value.total=tableData.value.rows.length
    }

    function getPage(){
      state.loading=true;
      call({
        url:urls.task,
        data:{startTask:project.value},
        success:(res)=>{
          state.loading=false
          if(res.status){
            var d=res.msg;
            staff.value=[];
            Object.keys(d.staff).forEach(k => {
              staff.value.push(d.staff[k])
            })
            page.value.title=d.title;
            setTable(d.tasks);
          }else{
            alert(res.msg);
          }
        }
      })
    }

    onMounted(() => {
      getPage()
    });

    function createTask(data){
      state.submitting=true;
      state.errors=[];
      data.createTask=(newFields.value.length-1).toString();
      call({
        url:urls.task,
        data:data,
        success:(res)=>{
          state.submitting=false;
          if(res.status){
            state.success=true;
            setTable(res.msg);
          }else{
            setErrors(res)
          }
        }
      })
    }

    function setErrors(res){
        var errors=[];
        Object.keys(res.msg).forEach(key => {
        var e=res.msg[key],er="";
        Object.keys(e).forEach(k => {
            er+=er=="" ? e[k] : ", "+e[k]
        })
        errors.push(er);
        });
        state.errors=errors;
    }

    function addAssignee(f){
      for(var i=0; i<newFields.value.length; i++){
        newFields.value[i].data.forEach(field => {
        if (f[field.name]) {
            field.value = f[field.name];
          }
        });
      }
      newFields.value.push(
        { name: "Assign task", number:(newFields.value.length+1).toString(),
      data: 
        [{ type: 'select', name: 'assignee_'+(newFields.value.length).toString(), label: 'Staff', placeholder: 'Institution', 
          options:staff }
        ]
      })
    }

    function mark(i){
        var data=tableData.value.rows[i],
        oldData=data.status;
        if(oldData != "1" && oldData != "0" && oldData != "2"){
          alert("Only assignees can mark or unmark a task");
          return;
        }
        tableData.value.rows[i].status="-1"
        call({
          url:urls.task,
          data:{markTask:data.id},
          success:(res)=>{
            state.submitting=false;
            if(res.status){
              setTable(res.msg)
            }else{
              tableData.value.rows[i].status=oldData
              setErrors(res)
            }
          }
        })
    }

    function getRowClass(row) {
      if(row.status=="-1"){return "marking"}
      if(row.status=="0" || row.status=="3"){return "completed"}
      if(row.status=="2" || row.status=="4"){return "overdue"}
      return "";
    }

    function editTask(i){
      state.success=false;
      state.errors=[];
      state.gettingTask=true
      var taskid=tableData.value.rows[i].id;
      editFields.length=0;
      call({
        url:urls.task,
        data:{getTask:taskid},
        success:(res)=>{
          state.gettingTask=false
          if(res.status){
            var nData={}
            var task=res.msg;
            editData.value['name']=task.name;
            editData.value['due']=task.due;
            editData.value['desc']=task.desc;
            editData.value['task_id']=taskid;
            var x=1;
            Object.keys(task.users).forEach(key => {
              var assignee=task.users[key];
              var name="assignee_"+x;
              editFields.push({name:name});
              editData.value[name]=assignee.value;
              editData.value[name+"_id"]=assignee.aid;
              nData[assignee.label]=assignee.value;
              x++;
            })
            Object.keys(staff.value).forEach(key => {
              var option = staff.value[key]
              if (nData[option.label] !== undefined) {
                  option.value = nData[option.label];
                }
            })
          }
        }
      })
      state.editTaskModal=true;
    }

    function addEFields(){
      var nn="assignee_"+(editFields.length + 1).toString();
      editFields.push({name:nn})
      editData.value[nn+"_id"]="new";
    }

    function updateTask(){
      state.submitting=true;
      state.errors=[];
      var data=editData.value;
      data.updateTask=(editFields.length).toString();
      call({
        url:urls.task,
        data:data,
        success:(res)=>{
          state.submitting=false;
          if(res.status){
            state.success=true;
            setTable(res.msg);
          }else{
            setErrors(res);
          }
        }
      })
    }

    function showHistory(i){
      state.historyModal=true;
      state.historyLoading=true;
      var data={getTaskHistory: tableData.value.rows[i].id};
      call({
        url:urls.task,
        data:data,
        success:(res)=>{
          state.historyLoading=false;
          if(res.status){
            history.value=res.msg;
          }else{
            alert(res)
          }
        }
      });
    }

    function deleteAssignee(i){
      var old=editFields[i],
      assignee_id=editData.value[old.name+"_id"];
      state.submitting=true;
      call({
        url:urls.task,
        data:{removeAssignee:assignee_id},
        success:(res)=>{
          state.submitting=false;
          if(res.status){
            editFields.splice(i,1)
            i=1;
            var nEditFields=[];
            Object.keys(editFields).forEach(function(){
              nEditFields.push({name:"assignee_"+i});
              i++;
            })
            editFields.length=0
            editFields.push(...nEditFields)
            var nData={}
            i=1;
            Object.keys(editData.value).forEach(key => {
              if(key.substring(0,10)==old.name ||  key.slice(-2) =="id" || key.length < 8){
                return;
              }
              var n="assignee_"+i;
              nData[n] =  editData.value[key];
              nData[n+"_id"]=editData.value[key+"_id"];
              i++
            })
            old=editData.value['name'];
            var old_id=editData.value['task_id'],
            old_due=editData.value['due'];
            editData.value=nData;
            editData.value['name']=old
            editData.value['task_id']=old_id
            editData.value['due']=old_due
            setTable(res.msg);
          }else{
            setErrors(res)
          }
        }
      })
    }

    watch(
      () => route.params.project,
      () => {
       getPage()
      }
    );

    function viewTask(i){
      state.modalLoading=true
      state.ViewModal=true;
      state.success=false;
      state.submitting=false;
      state.errors=[];
      var id=tableData.value.rows[i].id
      call({
        url:urls.task,
        data:{viewTask:id},
        success:(res)=>{
          state.modalLoading=false;
          if(res.status){
            viewFields.value.length=0;
            var d=res.msg;
            viewFields.value.push(
                { name: "Task Details", number: "1",data: 
                    [
                      {label: 'Project',name: 'project',
                      value: d.project},
                      { label: 'Name', name: 'name',
                      value: d.name  },
                      {  label: 'Deadline',name: 'deadline',
                      value: d.deadline},
                      {label: 'Description',name: 'desc',
                      value: d.description},
                      {label: 'Assignees',name: 'assignees',
                      value: d.assignees}
                    ]
                }
            );
          }else{
            setErrors(res)
          }
        }
      })
    }


    return{page,icons: svgIcons.value,tableData,state,createForm,mark,editTask,editData,showHistory,
        newFields,createNew,createTask,addAssignee,getRowClass,editFields,staff,addEFields,history,
        updateTask,deleteAssignee,viewTask,viewFields
    }
  }
})

</script>   

<style scoped>
p{color:var(--black); font-family: Inter, Helvetica, Arial, sans-serif;}
.box > *{padding: 0 calc(1.5rem * 0.5);}
.box .card{background:var(--white-color); border-radius: 0.5rem}
.card-header:first-child {border-radius: 0.5rem 0.5rem 0 0;padding: 0.5rem !important;
    padding-left: 1rem !important;background-color: var(--white-color);
    border-bottom: 0 solid #e5e5e5;}
.iconwrap{border-radius: 0.5rem; width: 48px;height: 48px; background-position: center;
    background-image: linear-gradient(195deg, #42424a 0%, #191919 100%);
    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.14), 0 7px 10px -5px rgba(64, 64, 64, 0.4) !important;
    text-align: center !important; display: flex; align-items: center; justify-content: center;}
.iconwrap .ic{width:18px; height:18px; fill:var(--white-color);line-height: 0em;}
.text-sm {font-size: 0.875rem !important; line-height: 1.5;}
.text-capitalize {text-transform: capitalize !important;}
h4{font-size: 1.5rem; line-height: 1.375; font-weight: 600;}
hr.horizontal.dark {background-image: linear-gradient(90deg, transparent, rgba(0, 0, 0, 0.4), transparent);}
.my-0 {margin-top: 0 !important; margin-bottom: 0 !important;}
hr.horizontal {background-color: transparent;}
hr {border-top: none; height: 1px;}
hr {color: inherit; border: 0; opacity: 0.25;}
.ps-3 {padding-left: 1rem !important;}
.p-2 {padding: 0.5rem !important;}
:deep(.completed .tdata .ic){fill:var(--primary-color) !important}
:deep(.marking .tdata .ic){display:none !important}
:deep(.overdue td:nth-child(3)){color:red !important; font-weight: bold}
</style>

<style scoped>
.temp-row{padding: 5px 10px; display:flex; gap:10px}
label{color:var(--black)}
.lbl{font-size: 14px; font-weight: bold;}
.temp-row select{background: rgba(255,255,255,0.1);
  border: none;
  font-size: 16px;
  height: auto;
  margin: 0;
  outline: 0;
  padding: 15px;
  width: 100%;
  background-color: var(--input-bg);
  color: #8a97a0;
  box-shadow: 0 1px 0 rgba(0,0,0,0.03) inset;
  margin: 5px 0;}
.btn-full{width: auto; margin: 0; padding: .375rem 24px;}
input[type=checkbox]{cursor: pointer;}
.temp-input{width:100%}
.temp-row.perm{border-bottom: 1px solid var(--background-color);
  padding-bottom: 10px; margin-bottom: 10px;}
.errors{padding: 0px 15px;}
.errors p{background:red; color:var(--always-white) !important; margin:5px; padding:5px 10px;
    border-radius: 10px; font-weight: bold; font-size: 14px;}
.success p{background: green; color: var(--always-white) !important; padding: 10px 20px;
    border-radius: 10px; font-weight: bold;}

.roles{margin:20px 0}
.role{display:flex; align-items: center; width: 100%; justify-content: space-between;}
.role > div{flex: 1; padding: 10px;}
.role > div:last-child{display:flex; align-items: center; max-width:100px}
.role:nth-child(odd){background: #ebebeb;}
.ic{height: 30px; fill: red; stroke:red; cursor: pointer; padding: 4px; display: flex; 
  align-items: center; justify-content: center;}

@media screen and (max-width: 700px) {
.role > div:last-child{display:none !important}
.role .mview{display:flex;align-items: center; max-width:100px}
.chbx{gap: 5px; flex-wrap: wrap; font-size: 13px;}
}
</style>